import React, { useState, useEffect, useRef } from 'react';
import './ChartModal.css';
import * as Yup from 'yup';
import { ImCancelCircle } from 'react-icons/im';
import * as d3 from "d3";
import * as Plot from '@observablehq/plot'
import BeatLoader from "react-spinners/BeatLoader";
import { doc, collection,query, where, getDocs  } from "firebase/firestore";
import { db } from '../../../firebase/firebase-config';
import useMeasure from 'react-use-measure'

const override = {
    marginTop: "20px",
  };

function ChartModal({ onCancel, user, color="#4F5052", } : any) {
    const [loading, setLoading] = useState(false);
    const [numCases, setNumCases] = useState(null);

    let chartRef: any = useRef();
    const [containerRef, bounds] = useMeasure()
    let allMaxes: any = []

    const fetchOtherCases = async () => {
        const casesDocRef =  query(collection(db, "Cases"), where("patient_uid", "==", user?.id));
        const docs = await getDocs(casesDocRef);

        let data: any =  [];

        docs.forEach((val: any) => {
            data.push({
                ...val.data(),
                id: val.id
            });
        })

        setNumCases(data.length);

        // console.log('DATA: ', data);
    }

    // useEffect(() => {
    //     fetchOtherCases();
    // },[])

    // useEffect(() => {
    //     let chart = Plot.plot({
    //         width: bounds.width,
    //         height: bounds.height,
    //         marginLeft: 30,
    //         marginRight: 10,
    //         x: {
    //             // tickFormat: (d) => format(d, "MMM d")
    //         },
    //         y: {
    //             label: null,
    //             grid:  true,
    //             labelOffset: 28,
    //             tickSize: 0
    //         },
    //         marks: [
    //             Plot.line(allMaxes, {
    //                 x: "date",
    //                 y: "estimatedMax",
    //                 stroke: "#0ea5e9",
    //                 strokeWidth: 2,
    //                 marker: "circle"
    //             })
    //         ]
    //     })

    //     chartRef?.current.append(chart)
    //     return () => chart.remove();
    // },[bounds.height, bounds.width])

    return (
        <div>
            <div  className='chart-modal-container modal-details'>
                <div className='modal-head' style={{backgroundColor: color}}>
                   
                    <p className="modal-title">Patient's Live Data</p>
                    <ImCancelCircle style={{cursor: 'pointer'}} onClick={onCancel} size={22} color="#fff"/>
                </div>
                <div style={{display: 'flex',  justifyContent: 'center', alignItems: 'center'}}>
                    <BeatLoader
                        color="#3080ED"
                        loading={loading}
                        cssOverride={override}
                    />
                    </div>
                <div className='details modal-content' ref={containerRef}>
                <div className="modal-content-row" >
                   <ChartInner data={[]} height={bounds.height} width={bounds.width}/>
                </div>
                </div>
            </div>
            <div className="modal-shadow" onClick={onCancel}>
           
            </div>
        </div>
    );
}

function ChartInner({data, height, width}: any) {
    let dummyData: any = [
        [0,10],
        [5,50],
        [15,75],
        [55,100],
        [75,10],
        [100,5],
        [140,100],
        [180,50]
    ]

    // @ts-ignore
    let xScale = d3.scaleLinear().domain(d3.extent(dummyData.map((d) => d[0]))).range([0, width])

    let line  = d3
                .line()
                .x((d) => xScale(d[0]))
                .y((d) => height - d[1]);

    let result: any = line(dummyData);


    console.log(result);
    return (
        <>
            <svg className='bg-gray-100' viewBox={`0 0 ${width} ${height}`}>
                <path d={result} fill='none' stroke='#0ea5e9'/>
            </svg>
        </>
    )
}

export default ChartModal;